export const analog = {
  _id: 'defaultAnalog',
  name: 'analog',
  kit: 'analog',
  bpm: 100,
  length: 64,
  patternStr:
    'S0s0ts3tn1pC2v1l1s5tS1s3tS2s3tS3s3tS4s1tS5s3tS6s0ts3tS7s3tS8s3tn1pC2v1l1n2pC2v1l1S9s3tS10s3tS11s0ts3tS12s1ts2tS13s3tS14s3tS15s3tS16s0tS17s3tS18s3tS19s0ts3tS20s1tS21s3tS22s0ts3tS23s0ts3tS25s3tS26s0ts3ts4tS27s3tS28s1ts2tS29s3tS30s3tS31s3tS32s0tS33s3tS34s3tS35s3tS36s1tS37s3tS38s0ts3tS39s3tS41s3tS42s0ts3tS43s3tS44s1ts2tS45s3tS46s3tS47s3tS48s0ts6tS49s3ts6tS50s3tS51s0ts3ts6tS52s1tS53s3ts7tS54s3ts6tS55s1ts3ts7tS56s0tS57s3ts7tS58s0ts1ts3ts4ts7tS59s3ts8tS60s1ts2ts4ts6tS61s0ts1ts3ts7tS62s0ts1ts3ts4ts7ts8tS63s0ts3ts8t',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S6p29S7p38S8p71',
};

export const house = {
  _id: 'defaultHouse',
  name: 'house',
  kit: 'house',
  bpm: 120,
  length: 64,
  patternStr:
    'S0s0ts1ts6tS1s3tv0.5l1S2s3ts4tS3s3tv0.5l1S4s1ts5tS5s3tS6s3tv0.5l1s4tS7s3tS8s1tS9s3tv0.5l1S10s0ts3ts4tS11s3tv0.5l1s8tS12s1ts2ts5tS13s3tS14s3tv0.5l1s4ts8tv0.5l1S15s3tS16s1tS17s3tv0.5l1S18s3ts4tS19s3tv0.5l1S20s1ts5tS21s3tv0.5l1S22s3ts4ts7tS23s3tv0.5l1s5tv0.5l1S24s1tS25s3tv0.5l1S26s0ts3ts4ts6tS27s3tv0.5l1s8tS28s1ts2ts5tS29s3tv0.5l1S30s3tv0.5l1s4ts8tv0.5l1S31s3tv0.5l1S32s0ts1ts6tS33s3tv0.5l1S34s3ts4tS35s3tv0.5l1S36s1ts5tS37s3tv0.5l1S38s3ts4tS39s3tv0.5l1S40s1tS41s3tv0.5l1S42s0ts3ts4tS43s3tv0.5l1s8tS44s1ts2ts5tS45s3tv0.5l1S46s3ts4ts8tv0.5l1S47s3tv0.5l1S48s1tS49s3tv0.5l1S50s3ts4tS51s3tv0.5l1s6tS52s1ts5tS53s3tv0.5l1S54s3ts4ts6ts7tS55s3tv0.5l1s5tv0.5l1s6tv0.5l1S56s1tS57s3tv0.5l1S58s0ts3ts4ts6tS59s3tv0.5l1s8tS60s1ts2ts5tS61s3tS62s3ts4ts5ts8tv0.5l1S63s3t',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S3p33S4p69S7p23S8p79',
};
export const burn = {
  _id: 'defaultBurn',
  name: 'burn',
  kit: 'lush',
  bpm: 80,
  length: 64,
  patternStr:
    'S0s0ts1ts3tS2s3tS3s2tS4s3ts5ts8tS5s3tv0.5l1S6s1ts3tS7s3tv0.5l1S8s3tS9s2ts3tv0.5l1S10s1ts3ts4tS12s3ts7ts8tS14s3tS16s0ts1ts3ts6tS17s5tv0.5l1S18s3ts6tS19s2tS20s3ts5ts6ts8tS21s3tv0.5l1s6tv0.5l1S22s1ts3ts6tS23s3tv0.5l1s5tv0.5l1s6tv0.5l1S24s3ts6tS25s2ts3tv0.5l1s5tv0.5l1s6tv0.5l1S26s1ts3ts4ts6tS27s6tv0.5l1S28s3ts6ts7ts8tS30s3tS32s0ts1ts3tS34s3tS35s2tS36s3ts5ts8tS37s3tv0.5l1S38s1ts3tS39s3tv0.5l1S40s3tS41s2ts3tv0.5l1S42s1ts4tS43s3tv0.5l1S44s3ts7ts8tS46s3tS48s0ts1ts3ts6tS49s5tv0.5l1S50s3ts6tS51s1ts2tS52s3ts5ts6ts8tS53s3tv0.5l1s6tv0.5l1S54s1ts3ts5tv0.5l1s6tS55s3tv0.5l1s5tv0.5l1s6tv0.5l1S56s3ts6tS57s2ts3tv0.5l1s5tv0.5l1s6tv0.5l1S58s1ts3ts4ts6tS59s3tv0.5l1s6tv0.5l1S60s3ts6ts7ts8tS61s3tS62s3tS63s3t',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S3p26S6p68',
};

export const vinyl = {
  _id: 'defaultVinyl',
  name: 'vinyl',
  kit: 'vinyl',
  bpm: 90,
  length: 64,
  patternStr:
    'S0s0ts1ts7tS1s1tv0.5l1s8tS2s3ts7tS3s1tS4s2ts5ts8tS5s7tv0.5l1S6s0ts3tS7s1ts7tv0.5l1s8tS9s1ts7ts8tS10s0ts3tS11s7tS12s2ts5ts8tS13s7tv0.5l1S14s3ts7tS15s7tv0.5l1S16s0ts1ts7tS17s1tv0.5l1s8tS18s3ts7tS20s2ts5ts8tS21s7tv0.5l1S22s0ts3tS23s7tv0.5l1s8tS25s1ts7ts8tS26s0ts3tS27s7tS28s2ts5ts8tS29s7tv0.5l1S30s3ts7tS31s7tv0.5l1S32s0ts1tS33s1tv0.5l1s8tS34s3tS35s1tS36s2ts5ts8tS38s0ts3tS39s1ts3tv0.5l1s8tS41s3tv0.5l1s8tS42s3tS43s3tv0.5l1S44s2ts3ts5ts8tS46s3tS48s0tS50s3tS52s2ts5ts8tS54s3tS55s3tv0.5l1s8tS56s8tS57s3tv0.5l1s8tS58s0ts3tS60s2ts5ts8t',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S3p23S6v72S7v90',
};

export const sauce = {
  _id: 'defaultSauce',
  name: 'sauce',
  kit: 'sauce',
  bpm: 120,
  length: 64,
  patternStr:
    'S0s0ts5tS2s3tS3s5tS4s1ts3tn1pC2v1l0.085s6tS5s3tpE2n1pE2v1l0.085S6s3tpG2n1pG2v1l0.085s5tS7s3tpC3n1pC3v1l0.085S8s2ts7tpG2S9s5tS10s0tS12s1ts5ts6tS15s5tS18s2tS19s5tS20s1ts6tS22s5tS24s2tS25s5tS26s0tv0.51l1S28s0ts1ts4tpC3s5ts6tS29s4pC3S30s4tpC3s5tS31s4pC3S35s5tS36s1ts6tS38s5tS40s2tS41s5tS42s8tpE2S44s0ts1ts5ts6tS45s0tS46s5ts6ts8pG2S50s2tS51s5tS52s1ts6tS54s5tS56s0ts2tS57s0ts5tS60s0ts1ts4tpC3s5ts6tS61s4pA2s5tS62s4tpF2s5tS63s5t',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S4v72p13S5v55p81',
};

export const funky = {
  _id: 'defaultFunky',
  name: 'funky',
  kit: 'punchy',
  bpm: 110,
  length: 64,
  patternStr:
    'S0s0ts5tS1s3tS2s2tS3s0tS4s1tS6s4tS7s2tS8s0tS9s3tS10s2tS11s0tS12s1tS15s2ts4tS16s0tS17s3tS18s2tS19s0tS20s1tS21s0tv0.63l1S22s0ts4tS23s1tS24s0tS25s3tS26s2tS27s0tS28s1ts4tS30s4tS31s2tS32s0tS33s3tS34s2tS35s0tS36s1tS38s4tS39s2tS40s0tS41s3tS42s2tS43s0tS44s1tS47s2ts6tn1pC2v1l1S48s0ts6tS49s3tS50s2tS51s0ts6tS52s1tS53s0tv0.63l1s7tn1pC2v1l1S54s0ts4ts7tS55s1tS56s0tS57s3ts8tS58s2tS59s0ts8tv0.59l1S60s1ts4ts8tS61s8tpG1v0.59l1S62s1ts4ts8tpG1S63s1ts8pF1',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S4v88S6v92p27S7v92p37S8p70',
};

export const saffron = {
  _id: 'defaultSaffron',
  name: 'saffron',
  kit: 'saffron',
  bpm: 90,
  length: 64,
  patternStr:
    'S0s0ts1ts3ts6tpC1s7ts8tpC1S2s2ts4ts5ts7tv0.52l0.1675S3s0ts2ts5ts7tv0.52l0.1675S4s3ts7ts8pC1S5s1ts4tS6s1ts5ts7tv0.52l0.1675S7s5ts7tv0.52l0.1675S8s0ts1ts3ts7ts8tpC1S10s4ts5ts7tv0.52l0.1675S11s0ts5ts7tv0.52l0.1675S12s3ts7ts8pC1S13s1ts4tS14s1ts5ts7tv0.52l0.1675S15s5ts7tv0.52l0.1675S16s0ts1ts3ts6pC1s7ts8tpC1S18s2ts4ts5ts7tv0.52l0.1675S19s0ts2ts5ts7tv0.52l0.1675S20s3ts7ts8pC1S21s1ts4tS22s1ts5ts7tv0.52l0.1675S23s5ts7tv0.52l0.1675S24s0ts1ts3ts4ts7ts8tpC1S26s4ts5ts6ts7tv0.52l0.1675S27s0ts5ts7tv0.52l0.1675S28s3ts7ts8pC1S29s1ts4ts6tv0.45l0.1075n1pC2v0.45l0.1075n2pC2v0.45l0.1075S30s1ts5ts6ts7tv0.52l0.1675S31s5ts6pC1s7tv0.52l0.1675S32s0ts1ts3ts6tpC1s7ts8tpC1S34s2ts4ts5ts7tv0.52l0.1675S35s0ts2ts5ts7tv0.52l0.1675S36s3ts7ts8pC1S37s1ts4tS38s1ts5ts7tv0.52l0.1675S39s5ts7tv0.52l0.1675S40s0ts1ts3ts7ts8tpC1S42s4ts5ts7tv0.52l0.1675S43s0ts5ts7tv0.52l0.1675S44s3ts7ts8pC1S45s1ts4tS46s1ts5ts7tv0.52l0.1675S47s5ts6pC1s7tv0.52l0.1675S48s0ts1ts3ts6pC1s7ts8tpC1S50s2ts4ts5ts7tv0.52l0.1675S51s0ts2ts5ts7tv0.52l0.1675S52s3ts7ts8pC1S53s1ts4tS54s1ts5ts7tv0.52l0.1675S55s5ts7tv0.52l0.1675S56s0ts1ts3ts4ts7ts8tpC1S58s4ts5ts6ts7tv0.52l0.1675S59s0ts5ts7tv0.52l0.1675S60s3ts4ts7ts8pC1S61s1ts4ts6tS62s1ts4ts5ts6ts7tv0.52l0.1675S63s5ts6ts7tv0.52l0.1675',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S4v88S6v92p27S7v92p37S8p70',
};

export const beatbox = {
  _id: 'defaultBeatbox',
  name: 'beatbox',
  kit: 'beatbox',
  bpm: 60,
  length: 64,
  patternStr:
    'S0s0ts1ts3ts5tS1s3tv0.41l1S2s3ts8tS3s3tv0.41l1S4s2ts3ts4tS5s3tv0.41l1S6s1ts3tS7s3tv0.41l1S8s3tS9s3tv0.41l1S10s3ts8tS11s1ts3tv0.41l1S12s2ts3tn1pC2v1l1n2pC2v1l1s4ts6tS13s3tn1pC2v1l1n2pC2v1l1S14s0tpG1s3tn1pC2v1l1S15s3tn1pC2v1l1S16s0ts1ts3tS17s3tv0.41l1S18s3ts8tS19s3tv0.41l1S20s2ts3ts4tS21s3tv0.41l1S22s1ts3tS23s3tv0.41l1S24s3tS25s3tv0.41l1s4tS26s3ts7ts8tS27s1ts3tv0.41l1S28s2ts3tn1pC2v1l1n2pC2v1l1s4ts6tS29s0tpG1s1ts3tn1pC2v1l1n2pC2v1l1s7tS30s0tpG1s1ts3tn1pC2v1l1S31s3tn1pC2v1l1S32s0ts1ts3tS33s3tv0.41l1S34s3ts8tS35s3tv0.41l1S36s2ts3ts4tS37s3tv0.41l1S38s1ts3tS39s3tv0.41l1S40s3tS41s3tv0.41l1S42s3ts8tS43s1ts3tv0.41l1S44s2ts3tn1pC2v1l1n2pC2v1l1s4ts6tS45s3tn1pC2v1l1n2pC2v1l1S46s0tpA#1s3tn1pC2v1l1S47s3tn1pC2v1l1S48s0tpG#1s1ts3tS49s1ts3tv0.41l1S50s3ts8tS51s1ts3tv0.41l1S52s2ts3ts4tS53s3tv0.41l1S54s0tpG1s3tS55s3tv0.41l1S56s1ts3tS57s3tv0.41l1s4tS58s3ts7ts8tS59s1ts3tv0.41l1S60s2ts3tn1pC2v1l1n2pC2v1l1s4ts6tS61s0tpG1s1ts3tn1pC2v1l1n2pC2v1l1s7tS62s0tpG1s1ts3tn1pC2v1l1S63s3tn1pC2v1l1',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S3v58S4p22S7p82',
};

export const electric = {
  _id: 'defaultElectric',
  name: 'electric',
  kit: 'electric',
  bpm: 80,
  length: 64,
  patternStr:
    'S0s0ts7tpC1s8tpC1n1pC1v1l0.065S1s4ts8tpG1n1pG1v1l0.065S2s3ts4ts6ts7ts8tpE2n1pE2v1l0.065S3s4ts8tpA#2n1pA#2v1l0.065S4s0ts2ts5ts8tpC1n1pC1v1l0.065S5s4ts6ts7tpC1s8tpG1n1pG1v1l0.065S6s3ts4ts8tpE2n1pE2v1l0.065S7s4ts5ts8tpA#2n1pA#2v1l0.065S8s0ts6ts7tpG#1s8tpC1S9s4ts8tpG#1S10s3ts4ts8tpD#2S11s4ts6ts8tpA#2S12s0ts1ts2ts5ts6ts7tpG1s8tpD1S13s4ts7tpG1s8pG1S14s3ts4ts6ts8tpF1S15s4ts6ts8pB1S16s0ts7tpC1s8tpC1n1pC1v1l0.065S17s4ts8tpG1n1pG1v1l0.065S18s3ts4ts6ts7ts8tpE2n1pE2v1l0.065S19s4ts8tpA#2n1pA#2v1l0.065S20s0ts2ts5ts8tpC1n1pC1v1l0.065S21s4ts6ts7tpC1s8tpG1n1pG1v1l0.065S22s3ts4ts8tpE2n1pE2v1l0.065S23s4ts5ts8tpA#2n1pA#2v1l0.065S24s0ts6ts7tpG#1s8tpC1S25s4ts8tpG#1S26s3ts4ts8tpD#2S27s4ts6ts8tpA#2S28s0ts1ts2ts5ts6ts7tpG1s8tpD1S29s4ts8pG1S30s3ts4ts6ts8tpF1S31s4ts6ts8pB1S32s0ts7tpC1s8tpC1n1pC1v1l0.065S33s4ts8tpG1n1pG1v1l0.065S34s3ts4ts6ts7ts8tpE2n1pE2v1l0.065S35s4ts8tpA#2n1pA#2v1l0.065S36s0ts2ts5ts8tpC1n1pC1v1l0.065S37s4ts6ts7tpC1s8tpG1n1pG1v1l0.065S38s3ts4ts8tpE2n1pE2v1l0.065S39s4ts5ts8tpA#2n1pA#2v1l0.065S40s0ts6ts7tpC1s8tpC1S41s4ts8tpG#1S42s3ts4ts8tpD#2S43s4ts6ts8tpA#2S44s0ts1ts2ts5ts6ts7tpC1s8tpD1S45s4ts8tpG1S46s3ts4ts6ts8tpF1n1pF1v1l0.065n2pF1v1l0.065S47s4ts6ts8tpB1n1pB1v1l0.065n2pB1v1l0.065S48s0ts7tpC1s8tpC1n1pC1v1l0.065S49s4ts8tpC1n1pC1v1l0.065S50s3ts4ts7ts8tpC1n1pC1v1l0.065S51s4ts8tpC1n1pC1v1l0.065S52s0ts2ts5ts8tpC1n1pC1v1l0.065S53s4ts7tpC1s8tpC1n1pC1v1l0.065S54s3ts4ts8tpC1n1pC1v1l0.065S55s4ts5ts8tpC1n1pC1v1l0.065S56s0ts7tpG#1s8tpC1n1pC1v1l0.065n2pC1v1l0.065S57s4ts8tpC1n1pC1v1l0.065n2pC1v1l0.065S58s3ts4ts8tpC1n1pC1v1l0.065n2pC1v1l0.065S59s4ts7ts8tpC1n1pC1v1l0.065n2pC1v1l0.065S60s0ts1ts2ts5ts7tpG1s8pC1S61s4ts8pC1S62s3ts4ts8pC1S63s4ts8pC1',
  mainMixerStr: 'v80',
  sampleMixerStr: 'S2v77S3v53p48S4v78p100S6p0S8v68',
};

export const defaultSequences = [
  analog,
  house,
  burn,
  vinyl,
  sauce,
  funky,
  saffron,
  beatbox,
  electric,
];
